export default __webpack_public_path__ + "static/media/graduate-success.23934608.png";